import FormattedMessage from 'I18n/components/FormattedMessage';
import { AlertTip, BodySmall, Caption, LayoutBox, LayoutSpaceVertical, Link } from 'breeze-intelligence-kit';
import { useEnrichmentCredits } from './EnrichmentCreditsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DisclaimerMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "enrichmentCredits.disclaimer"
});
export const DisclaimerMessageOverage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "enrichmentCredits.disclaimerOverage"
});
export const DisclaimerMessageOveragePanel = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "enrichmentCredits.disclaimerOveragePanel"
});
const DisclaimerMessageUpgradeAlert = ({
  isAutoUpgradeEnabled,
  showOverage
}) => {
  if (showOverage) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.usageOverageAlert"
    });
  }
  if (!isAutoUpgradeEnabled) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.usagePausedAlert"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "hubSpotCredits.upgradeAlert"
  });
};
export const DisclaimerText = ({
  isVisible = true
}) => {
  const {
    isHubspotCredits,
    isAutoUpgradeEnabled,
    showOverage
  } = useEnrichmentCredits();
  const href = 'https://knowledge.hubspot.com/account/understand-breeze-intelligence-credits-and-billing';
  if (!isVisible) {
    return null;
  }
  if (isHubspotCredits) {
    return /*#__PURE__*/_jsx(LayoutBox, {
      children: /*#__PURE__*/_jsx(AlertTip, {
        alignSelf: "center",
        minBlockSize: "inherit",
        paddingBlock: "space-sm",
        children: /*#__PURE__*/_jsx(BodySmall, {
          as: "div",
          children: /*#__PURE__*/_jsx(DisclaimerMessageUpgradeAlert, {
            isAutoUpgradeEnabled: isAutoUpgradeEnabled,
            showOverage: showOverage !== null && showOverage !== void 0 ? showOverage : false
          })
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
    gap: "space-xxs",
    children: [/*#__PURE__*/_jsx(Caption, {
      as: "div",
      children: showOverage ? /*#__PURE__*/_jsx(DisclaimerMessageOverage, {}) : /*#__PURE__*/_jsx(DisclaimerMessage, {})
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: href,
      target: "_blank",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.modals.enrichRecords.learnMore"
      })
    })]
  });
};